export const Nam = () => (
  <div className={'flex-1 bg-zinc-800 rounded-lg overflow-hidden border border-zinc-700'}>
    <div className={'bg-zinc-700 px-4 py-3 font-semibold text-white'}>NAM Captures</div>
    <div className={'flex flex-col text-sm'}>
      <div className={'px-4 py-3 border-b border-zinc-700'}>
        Amp + Cab (Combos and Stacks)
      </div>
      <div className={'px-4 py-3 border-b border-zinc-700'}>Amp Heads</div>
      <div className={'px-4 py-3'}>Pedals and Outboard Gear</div>
    </div>
  </div>
);

export const Ir = () => (
  <div className={'flex-1 bg-zinc-800 rounded-lg overflow-hidden border border-zinc-700'}>
    <div className={'bg-zinc-700 px-4 py-3 font-semibold text-white'}>IR Captures</div>
    <div className={'flex flex-col text-sm'}>
      <div className={'px-4 py-3 border-b border-zinc-700'}>Speaker Cabinets</div>
      <div className={'px-4 py-3 border-b border-zinc-700'}>Reverb</div>
      <div className={'px-4 py-3'}>Room Acoustics</div>
    </div>
  </div>
);

export const NamVsIr = () => (
  <div className={'flex flex-col lg:flex-row gap-4 w-full'}>
    {/* NAM Captures Table */}
    <Nam />

    {/* IR Captures Table */}
    <Ir />
  </div>
);
